/**
 * @generated SignedSource<<54093780215768f0709cd2cf72ea6360>>
 * @relayHash f5e70c9be7fdc3563bfae3d66d390c91
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f5e70c9be7fdc3563bfae3d66d390c91

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type De_signTherapyPrescriptionDocumentWithTelematikInfrastructureInput = {
  id: string;
};
export type useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation$variables = {
  input: De_signTherapyPrescriptionDocumentWithTelematikInfrastructureInput;
};
export type useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation$data = {
  readonly de_signTherapyPrescriptionDocumentWithTelematikInfrastructure: {
    readonly de_TherapyPrescription: {
      readonly fileId: string | null;
      readonly id: string;
      readonly signedAt: string | null;
      readonly signedBy: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"deTherapyPrescriptionFragment">;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly errorType?: string;
      readonly message?: string;
    }> | null;
  };
};
export type useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation = {
  response: useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation$data;
  variables: useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedBy",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "type": "Error",
      "abstractKey": "__isError"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorType",
          "storageKey": null
        }
      ],
      "type": "SignDocumentMutationFailed",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_signTherapyPrescriptionDocumentWithTelematikInfrastructurePayload",
        "kind": "LinkedField",
        "name": "de_signTherapyPrescriptionDocumentWithTelematikInfrastructure",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_TherapyPrescription",
            "kind": "LinkedField",
            "name": "de_TherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "deTherapyPrescriptionFragment"
              }
            ],
            "storageKey": null
          },
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_signTherapyPrescriptionDocumentWithTelematikInfrastructurePayload",
        "kind": "LinkedField",
        "name": "de_signTherapyPrescriptionDocumentWithTelematikInfrastructure",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_TherapyPrescription",
            "kind": "LinkedField",
            "name": "de_TherapyPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "treatmentUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "frequency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requestTherapyReport",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "diagnosisCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "symptoms",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "otherSymptoms",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "additionalInformation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progressNoteId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "therapy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DocumentFileMetadata",
                "kind": "LinkedField",
                "name": "fileMetadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "extension",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lengthInKilobytes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "f5e70c9be7fdc3563bfae3d66d390c91",
    "metadata": {},
    "name": "useDeSignTherapyPrescriptionWithTelematikInfrastructureMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "00f0aa8674de341cfee955a8edccd81b";

export default node;
